import WidgetWeatherContainer from './WidgetWeatherContainer';

export default WidgetWeatherContainer;
